// import axiosInstance from "../../../axios";
// import config from "../../../config";
// import { usePersistedStore } from "../../persisted-store";

// export const createLoginReportSlice = (set, get) => ({
//     crmLoginReport: {
//         loading: false,
//         data: []
//     },
//     getCrmLoginReport: async (UsrUserID) => {
//         const token = usePersistedStore.getState().business.currentBusiness.token;
//         set(state => ({ crmLoginReport: { ...state.crmLoginReport, loading: true } }));
//         try {
//             const resp = await axiosInstance({
//                 method: 'get',
//                 baseURL: config.apiUrls(),
//                 url: `v1/crm/login-report/user/${UsrUserID}`,
//                 headers: { token }
//             });
//             set(state => ({ crmLoginReport: { loading: false, data: resp.data } }));
//         } catch (error) {
//             set(state => ({ crmLoginReport: { ...state.crmLoginReport, loading: false } }));
//         }
//     }
// });
import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createLoginReportSlice = (set, get) => ({
    crmLoginReport: {
        loading: false,
        data: []
    },
    getCrmLoginReport: async (params) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ crmLoginReport: { ...state.crmLoginReport, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'post',
                baseURL: config.apiUrls(),
                url: `v1/crm/login-report/user/${params.usrUserID}`,
                headers: { token },
                data: {
                    PageNumber: params.PageNumber,
                    PageSize: params.PageSize,
                },
            });
            set(state => ({ crmLoginReport: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ crmLoginReport: { ...state.crmLoginReport, loading: false } }));
        }
    }
});

